"use strict";
// LuXe : animations de la page d'accueil (apparition, compteurs, héros, miniatures, scanner, conseiller de taille).
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const calme = matchMedia("(prefers-reduced-motion: reduce)").matches;

  // Apparition au défilement
  const io = "IntersectionObserver" in window
    ? new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } }), { threshold: 0.14 })
    : null;
  $$(".rv").forEach((el) => (io ? io.observe(el) : el.classList.add("in")));

  // Compteurs
  if ("IntersectionObserver" in window) {
    const co = new IntersectionObserver((es) => es.forEach((e) => {
      if (!e.isIntersecting) return;
      co.unobserve(e.target);
      const el = e.target;
      // le prix de l'accueil attend que la devise soit prête (luxe-devise.js), pour ne pas sauter d'une devise à l'autre
      const lancer = () => {
      const cible = parseFloat(el.dataset.count), dep = parseFloat(el.dataset.from) || 0, dec = +el.dataset.dec || 0;
      if (isNaN(cible)) return;
      // prix dans une autre devise (voir luxe-devise.js) : format de la devise, symbole compris
      const ecrire = (v, d) => el.dataset.devise
        ? (el.dataset.approx ? "≈ " : "") + new Intl.NumberFormat(el.dataset.locale || "fr-FR", { style: "currency", currency: el.dataset.devise, currencyDisplay: "narrowSymbol", minimumFractionDigits: +el.dataset.dec || 0, maximumFractionDigits: +el.dataset.dec || 0 }).format(v)
        : v.toLocaleString("fr-FR", { minimumFractionDigits: d, maximumFractionDigits: d });
      const fin = () => {
        el.textContent = ecrire(parseFloat(el.dataset.count), dec);
        const carte = el.closest(".stat, .meta-prix");
        if (carte) carte.classList.add("done");
      };
      if (calme) return fin();
      // Le prix du héros attend la fin de l'apparition du texte, pour que l'on voie bien 99,99 descendre.
      const hero = el.hasAttribute("data-hero"), delai = hero ? 1500 : 0, duree = hero ? 2600 : 1600;
      setTimeout(() => {
        const t0 = performance.now();
        (function pas(t) {
          const p = Math.min(1, (t - t0) / duree), v = dep + (cible - dep) * (1 - Math.pow(1 - p, 3));
          el.textContent = ecrire(v, dec);
          if (p < 1) requestAnimationFrame(pas); else fin();
        })(t0);
      }, delai);
      };
      (el.hasAttribute("data-eur-count") && window.LUXE_DEVISE_PRET ? window.LUXE_DEVISE_PRET : Promise.resolve()).then(lancer);
    }), { threshold: 0.6 });
    $$("[data-count]").forEach((el) => co.observe(el));
  } else {
    $$("[data-count]").forEach((el) => { el.textContent = el.dataset.count; });
  }

  // Héros : alternance entre les deux visuels
  const hud = $(".hud");
  if (hud) {
    const tees = $$("img.tee", hud), nom = $("[data-hud-name]", hud);
    if (tees.length === 2 && !calme) {
      let a = true;
      setInterval(() => {
        a = !a;
        tees[0].classList.toggle("off", !a); tees[1].classList.toggle("off", a);
        if (nom) nom.textContent = a ? nom.dataset.a : nom.dataset.b;
      }, 4200);
    }
  }

  // Cartes produit : changement de photo avec les miniatures
  $$(".pcard").forEach((card) => {
    const img = $(".pimg img", card);
    $$(".thumbs button", card).forEach((btn) => btn.addEventListener("click", () => {
      $$(".thumbs button", card).forEach((b) => b.classList.toggle("on", b === btn));
      if (!img) return;
      img.style.opacity = 0;
      setTimeout(() => { img.srcset = ""; img.src = btn.dataset.src; img.style.opacity = 1; }, 180);
    }));
  });

  // Scanner : le terminal s'écrit à partir des données réelles du produit
  const sc = $("[data-scanner]");
  if (sc) {
    let data = { lignes: [], produits: [] };
    try { data = JSON.parse($("[data-scan-json]").textContent); } catch (e) { /* données illisibles : scanner vide */ }
    const term = $("[data-term]", sc), prog = $("[data-prog]", sc), img = $("[data-scan-img]", sc);
    const esc = (v) => String(v ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
    let run = 0;
    const lignes = (p) => {
      const L = [['<span class="m">$</span> <span class="k">luxe.scan</span> --produit <span class="v">"' + esc(p.titre) + '"</span>', 8],
        ['<span class="m">› lecture de la fiche produit…</span>', 18]];
      const extra = (p.lignes || data.lignes || []).map((l) => l.split("|")).filter((l) => l[0] && l[0].trim() && l[1]);
      const total = extra.length + 2;
      extra.forEach(([k, v], i) => L.push(['<span class="ok">✓</span> ' + esc(k.trim()).padEnd(12, ".").replace(/\./g, "·") + ' <span class="v">' + esc(v.trim()) + "</span>", 18 + ((i + 1) * 60) / total]));
      if (p.tailles) L.push(['<span class="ok">✓</span> tailles ······ <span class="v">' + esc(p.tailles) + "</span>", 88]);
      L.push(['<span class="ok">✓</span> prix ········· <span class="v">' + esc(p.prix) + "</span>", 100], ["", 100],
        ['<span class="ok">analyse terminée.</span> Source : fiche produit de la boutique.', 100]);
      return L;
    };
    const attente = (ms) => new Promise((r) => setTimeout(r, calme ? 0 : ms));
    async function scanner(i) {
      const id = ++run, p = data.produits[i];
      if (!p) return;
      term.innerHTML = ""; prog.style.width = "0";
      for (const [html, pct] of lignes(p)) {
        if (id !== run) return;
        term.innerHTML += html + "\n"; prog.style.width = pct + "%";
        await attente(html ? 430 : 120);
      }
      if (id === run) term.innerHTML += '<span class="caret"></span>';
    }
    $$("[data-picker] button", sc).forEach((b) => b.addEventListener("click", () => {
      $$("[data-picker] button", sc).forEach((x) => x.classList.toggle("on", x === b));
      const p = data.produits[+b.dataset.i];
      if (img && p && p.image) { img.srcset = ""; img.src = p.image; }
      scanner(+b.dataset.i);
    }));
    if ("IntersectionObserver" in window) {
      const so = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { scanner(0); so.disconnect(); } }), { threshold: 0.35 });
      so.observe(sc);
    } else scanner(0);
  }

  // Conseiller de taille (règles simples, indicatives) : accueil et fiche produit
  $$("[data-size]").forEach((sz) => {
    const T = (sz.dataset.tailles || "XS,S,M,L,XL").split(",").map((s) => s.trim()).filter(Boolean);
    const n = T.length - 1;
    const pick = $("[data-size-pick]", sz);
    let coupe = 0, taille = T[2];
    const maj = () => {
      const h = +$("[data-in-h]", sz).value, w = +$("[data-in-w]", sz).value;
      $("[data-o-h]", sz).textContent = h + " cm"; $("[data-o-w]", sz).textContent = w + " kg";
      let i = w < 55 ? 0 : w < 65 ? 1 : w < 78 ? 2 : w < 90 ? 3 : 4;
      if (h >= 185) i += 1; else if (h <= 160) i -= 1;
      i = Math.max(0, Math.min(n, i + coupe));
      taille = T[i];
      $("[data-size-out]", sz).textContent = T[i];
      $("[data-size-txt]", sz).textContent = coupe ? "Pour une coupe plus ample, on te conseille cette taille." : "Pour une coupe ajustée, cette taille devrait t'aller.";
      $("[data-size-alt]", sz).textContent = "Hésitation ? Essaie aussi " + (i < n ? T[i + 1] : T[i - 1]);
      if (pick) pick.textContent = "Choisir la taille " + T[i];
    };
    $$("input[type=range]", sz).forEach((r) => r.addEventListener("input", maj));
    $$("[data-seg] button", sz).forEach((b) => b.addEventListener("click", () => {
      coupe = +b.dataset.f; $$("[data-seg] button", sz).forEach((x) => x.classList.toggle("on", x === b)); maj();
    }));
    // fiche produit : coche directement la taille conseillée
    if (pick) pick.addEventListener("click", () => {
      const r = $$("input[data-variant]").find((x) => x.nextElementSibling && x.nextElementSibling.textContent.trim().toUpperCase() === taille.toUpperCase());
      if (r && !r.disabled) { r.checked = true; r.dispatchEvent(new Event("change", { bubbles: true })); r.closest("form").scrollIntoView({ behavior: calme ? "auto" : "smooth", block: "center" }); pick.textContent = "Taille " + taille + " sélectionnée ✓"; }
      else pick.textContent = "Taille " + taille + " indisponible pour le moment";
    });
    maj();
  });

  // Inscriptions par e-mail : après l'envoi, Shopify revient sur la page avec ?customer_posted=true#<id du formulaire>
  const subId = location.hash.slice(1);
  $$("[data-lx-sub]").forEach((f) => {
    if (!subId || f.id !== subId) return;
    const ok = $(".lx-sub-ok", f), err = $("[data-err]", f);
    if (err) err.hidden = false;
    else if (/customer_posted=true/.test(location.search) && ok) { ok.hidden = false; $(".lx-sub-row", f).hidden = true; }
    f.scrollIntoView({ block: "center" });
  });
})();
